import { useEffect, useState } from 'react';

interface ShareModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

const socials = [
  { name: '微博', icon: 'ri-weibo-fill', color: 'bg-accent-500' },
  { name: '微信', icon: 'ri-wechat-fill', color: 'bg-primary-500' },
  { name: 'QQ', icon: 'ri-qq-fill', color: 'bg-secondary-500' },
  { name: '抖音', icon: 'ri-tiktok-fill', color: 'bg-foreground-800' },
];

export default function ShareModal({ open, onClose, title }: ShareModalProps) {
  const [copied, setCopied] = useState(false);
  const [socialMsg, setSocialMsg] = useState('');

  useEffect(() => {
    if (!open) {
      setCopied(false);
      setSocialMsg('');
    }
  }, [open]);

  if (!open) return null;

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const input = document.createElement('input');
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
    }
    setCopied(true);
    setSocialMsg('');
    window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-foreground-950/50 px-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-sm rounded-lg bg-background-50 p-5 animate-pop-in"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="font-heading font-bold text-lg text-foreground-950">分享这篇文章</h3>
            <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{title}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-500 hover:bg-background-100 cursor-pointer"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>

        <div className="grid grid-cols-4 gap-3 mt-5">
          {socials.map((item) => (
            <button
              key={item.name}
              type="button"
              onClick={() => {
                setCopied(false);
                setSocialMsg(`已唤起${item.name}分享（演示）`);
              }}
              className="flex flex-col items-center gap-1.5 cursor-pointer"
            >
              <span
                className={`w-11 h-11 flex items-center justify-center rounded-full text-background-50 ${item.color}`}
              >
                <i className={`${item.icon} text-lg`} />
              </span>
              <span className="text-xs text-foreground-600">{item.name}</span>
            </button>
          ))}
        </div>

        <div className="mt-5">
          <button
            type="button"
            onClick={copyLink}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className={copied ? 'ri-check-line' : 'ri-link'} />
            {copied ? '链接已复制' : '复制链接'}
          </button>
          {socialMsg && (
            <p className="mt-2 text-xs text-center text-secondary-700">{socialMsg}</p>
          )}
          <p className="mt-2 text-[11px] text-center text-foreground-400">
            以上分享为前端演示，未接入真实平台接口
          </p>
        </div>
      </div>
    </div>
  );
}